
export default function Problem() {
  return (
    <section className="relative py-16 bg-[#0a1628]">
      <div className="max-w-5xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" style={{ fontFamily: "'Roboto', sans-serif" }}>
            WHY THE <span className="text-[#DC2626]">BULLY</span> ALWAYS WINS
          </h2>
          <div className="w-24 h-1 bg-[#DC2626] mx-auto"></div>
        </div>

        {/* Content Card */}
        <div className="bg-[#0f1d2e] border-2 border-[#DC2626]/30 rounded-xl p-10 md:p-14 shadow-2xl">
          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed">
            <p className="text-white font-bold text-2xl">
              "The world is full of predators—shady contractors, power-tripping HOA boards, and insurance companies that deny claims.
            </p>
            
            <p>
              They bully you because they know a secret: <span className="text-[#DC2626] font-bold">You won't sue them.</span>
            </p>
            
            <p>
              They know a lawyer costs <span className="text-white font-bold">$450/hour</span>. They know you can't afford the fight.
            </p>
            
            <p className="text-white font-black text-2xl pt-4 border-t-2 border-[#DC2626]/30">
              It's time to change the math."
            </p>
          </div>

          {/* Visual Elements */}
          <div className="grid grid-cols-3 gap-6 mt-12 pt-12 border-t border-gray-700">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-3 bg-[#DC2626]/20 rounded-full flex items-center justify-center">
                <i className="ri-tools-fill text-3xl text-[#DC2626]"></i>
              </div>
              <p className="text-sm text-gray-400 font-semibold">Shady Contractors</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-3 bg-[#DC2626]/20 rounded-full flex items-center justify-center">
                <i className="ri-home-4-fill text-3xl text-[#DC2626]"></i>
              </div>
              <p className="text-sm text-gray-400 font-semibold">HOA Boards</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-3 bg-[#DC2626]/20 rounded-full flex items-center justify-center">
                <i className="ri-file-damage-fill text-3xl text-[#DC2626]"></i>
              </div>
              <p className="text-sm text-gray-400 font-semibold">Insurance Denials</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
